export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/animation_for_streamers.e468ced.svg";